<form class="banner-signup base-email-signup container">

  <div class="banner-signup-form-container">
    <div class="banner-signup-info-container col4">
      <h2 class="banner-signup-title">Newsletters</h2>
      <p class="banner-signup-description">Get the best criminal justice news and analysis, in your inbox.</p>
      <p class="banner-signup-more-container">
        <a class="banner-signup-more-link" href="/newsletters?ref=banner-details">More about our emails</a>
      </p>
    </div>

    <div class="newsletter-options-list col8">
      {{#newsletters}}
      <label class="newsletter-option-item subscribe-column" tabindex="0">
        <input style="display: none;" type="checkbox" name="{{id}}" value="{{id}}" class="newsletter-option-input" {{#default_subscribe}}checked{{/default_subscribe}}>
        <div class="newsletter-option-checkbox">
          <?xml version="1.0" encoding="utf-8"?>
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 55.36 55.36" style="enable-background:new 0 0 55.36 55.36;" xml:space="preserve">
            <polyline class="subscribe-checkmark" points="6.29,27.21 23.16,45.21 51.29,9.21 "/>
          </svg>
        </div>
        <div class="newsletter-option-text-container">
          <span class="newsletter-option-tagline">{{tagline}}</span>
        </div>
      </label>
      {{/newsletters}}
      <div class="subscribe-error-container col12"></div>
    </div>
  </div>


  <div class="banner-signup-display-container">
    <h2 class="col8 banner-signup-tagline">
      {{#banner_tagline}}{{{banner_tagline}}}{{/banner_tagline}}
      {{^banner_tagline}}We drill down on one topic in this week’s news.{{/banner_tagline}}
    </h2>
  </div>

  <div class="col8 omega banner-signup-display-column banner-signup-display-button-container">
      <div class="subscribe-column subscribe-input-column form-column">
        {{! This is a honey-pot field for spambots. A real user should never fill it out. }}
        <input type="text" tabindex="-1" hidden name="comment">
        <input type="email" name="email" class="subscribe-email-input" placeholder="Enter your email address">
      </div>
      <div class="subscribe-column form-column">
        <button type="button" class="subscribe-button subscribe-intro-button-js">
          {{#button_text}}{{{button_text}}}{{/button_text}}
          {{^button_text}}Sign up{{/button_text}}
        </button>
      </div>
  </div>

  <div class="banner-signup-success-container">
    <h2 class="col12 banner-signup-display-column banner-signup-success-message">Thank you for subscribing. Please consider becoming a member today.</h2>
  </div>
</form>
